import React from 'react';

import './Spinner.css';

interface ISpinnerProps extends React.SVGAttributes<SVGElement> {
  /**
   * If true, forces the element to be centred over content using absolute positioning (needs relative parent)
   * @default false
   */
  centerOverContent?: boolean;
  /**
   * Determines the size of the spinner
   * @default 'standard'
   */
  size?: 'small' | 'standard' | 'medium' | 'large' | 'xlarge';
  /**
   * Determines the color of the spinner
   * @default 'inherit'
   */
  variant?: 'primary' | 'secondary' | 'neutral' | 'inherit' | 'white';
}

export const Spinner: React.FC<React.PropsWithChildren<ISpinnerProps>> = ({
  centerOverContent = false,
  size = 'standard',
  variant = 'inherit',
  className,
  ...props
}) => {
  return (
    <div role="status" className={`${centerOverContent ? 'absolute-center' : ''}`}>
      <svg
        aria-hidden="true"
        className={`spinner spinner-${size} spinner-${variant} ${className ?? ''}`}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        {...props}
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
      <span className="sr-only">Loading</span>
    </div>
  );
};
